import React from "react";
import { ThemeContext } from "grommet";
const ThemeContextExtend = props => (
  <ThemeContext.Extend {...props}>{props.children}</ThemeContext.Extend>
);
export default ThemeContextExtend;
